import * as React from 'react';
import classNames from 'classnames';
import './Switch.scss';

export interface ISwitchProps {
  checked?: boolean;
  disabled?: boolean;
  size?: 'small';
  onChange?(value: boolean): void
}

const Switch = ({
  checked,
  disabled,
  size,
  onChange,
}: ISwitchProps) => (
  <div
    className={classNames(
      'switch',
      disabled && 'is-disabled',
      size && `is-${size}`,
      checked && 'is-checked'
    )}
    onClick={() => {
      if (onChange && !disabled) {
        onChange(checked === true ? false : true);
      }
    }}
  />
);

export default Switch;



// WEBPACK FOOTER //
// ./src/components/FormElements/Switch.tsx